import { stringify } from 'query-string';

export const getQueryStringFromFilters = <T>(filters: T) => {
  return `${filters ? `?${stringify(filters)}` : ''}`;
};
